import CustomDatepickerSelected from 'components/common/CustomDatepickerSelected';
import { BACKSPACE_CODE, DELETE_CODE } from 'components/common/func';
import { datePicker, formatter } from 'helpers';
import { Fade } from 'helpers/animation';
import useFormInput from 'hooks/form/useFormInput';
import useLang from 'hooks/useLang';
import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import {
  DESKTOP_MIN_WIDTH,
  REGISTER_DOB_NAME,
  REGISTER_PERSONAL_DETAILS_DOB_FIELD,
} from '../../../../../constants';
import CalendarIcon from '../../../../common/Icons/CalendarIcon';
import { checkFormInputValidation } from '../../func';

const FormInputDatepickerValidation = ({
  ref,
  information,
  setInformation,
  validation,
  setValidation,
}) => {
  const { t } = useLang();

  const [isShowDatePickerIcon, setShowDatePickerIcon] = useState(true);
  const [isOpenDatePicker, setOpenDatePicker] = useState(false);
  const [datePickerISO, setDatePickerISO] = useState(null);
  const [dateMaskStr, setDateMaskStr] = useState(null);

  const dateFormat = formatter.formatParse(datePicker.dateFormat);

  const {
    inputRef,
    resetFormInput,
    setInformationFormInput,
    setValidationFormInput,
    getValueTrim,
    FormLabel,
    FormControlFeedback,
  } = useFormInput(REGISTER_PERSONAL_DETAILS_DOB_FIELD);

  useEffect(() => {
    if (information[REGISTER_DOB_NAME]) {
      const dateISO = datePicker.dateUTCToDateISO(
        information[REGISTER_DOB_NAME]
      );
      setDatePickerISO(dateISO);

      const { dateMask } = datePicker.getDateMask(
        '',
        information[REGISTER_DOB_NAME]
      );
      setDateMaskStr(formatter.mask(dateMask, dateFormat));
    }
  }, [information]);

  const handleOnChange = (dateUTC) => {
    let newInfomation = { ...information };
    let newValidation = { ...validation };

    const dateISO = datePicker.dateUTCToDateISO(dateUTC);
    const dateMask = datePicker.dateUTCToDateStr(dateUTC)?.split('/')?.join('');

    setDatePickerISO(dateISO);

    setDateMaskStr(dateMask);

    newInfomation = setInformationFormInput({
      value: datePicker.getDateUTC(
        dateUTC.getDate(),
        dateUTC.getMonth(),
        dateUTC.getFullYear()
      ),
      information: newInfomation,
      setInformation,
    });

    setValidationFormInput({
      validation: newValidation,
      setValidation,
      checkFormInputValidation: () =>
        checkFormInputValidation(
          newInfomation[REGISTER_PERSONAL_DETAILS_DOB_FIELD.name],
          REGISTER_PERSONAL_DETAILS_DOB_FIELD,
          newInfomation,
          newValidation
        ),
    });

    setOpenDatePicker(false);
  };

  const handleInputOnChange = (e) => {
    const { value } = e.target;
    let valueTrim = getValueTrim(value);

    if (valueTrim?.length > 10) return;

    let newValidation = { ...validation };

    setShowDatePickerIcon(true);

    if (!valueTrim) {
      // resetFormInput({
      //   information,
      //   setInformation,
      //   validation,
      //   setValidation,
      // });
      let newInformation = setInformationFormInput({
        value: '',
        information,
        setInformation,
      });
      setValidationFormInput({
        validation,
        setValidation,
        checkFormInputValidation: () =>
          checkFormInputValidation(
            newInformation[name],
            REGISTER_PERSONAL_DETAILS_DOB_FIELD,
            newInformation,
            validation
          ),
      });
      setDateMaskStr('');
      return;
    }

    const { dateMask, dd, MM, yyyy } = datePicker.getDateMask(valueTrim);
    setDateMaskStr(formatter.mask(dateMask, dateFormat));

    newValidation = {
      ...newValidation,
      [REGISTER_DOB_NAME]: '',
    };

    if (valueTrim.length === 10) {
      const dateUTC = datePicker.getDateUTC(dd, MM - 1, yyyy);
      const dateISO = datePicker.dateUTCToDateISO(dateUTC);
      const currentYear = new Date(dateISO).getFullYear();

      if (
        datePicker.minYear > currentYear ||
        datePicker.maxYear < currentYear
      ) {
        setShowDatePickerIcon(false);

        setDatePickerISO(null);
      } else {
        setShowDatePickerIcon(true);

        setDatePickerISO(dateISO);
      }

      setInformationFormInput({
        value: dateUTC,
        information,
        setInformation,
      });

      const isOfAgeToUse = datePicker.getOfAgeToUse(dateUTC);
      if (!isOfAgeToUse) {
        newValidation = {
          ...newValidation,
          [REGISTER_DOB_NAME]: REGISTER_PERSONAL_DETAILS_DOB_FIELD.msgInvalid,
        };
      }
    }

    setValidation(newValidation);
  };

  const handleInputOnKeyDown = (e) => {
    if ([BACKSPACE_CODE, DELETE_CODE].includes(e.which)) {
      resetFormInput({
        information,
        setInformation,
        validation,
        setValidation,
      });
      setDateMaskStr('');
      setShowDatePickerIcon(true);
    }
  };

  const handleOnToggleDatePicker = () => {
    if (!isOpenDatePicker && validation[REGISTER_DOB_NAME]) {
      // resetFormInput({
      //   information,
      //   setInformation,
      //   validation,
      //   setValidation,
      // });
      // setDateMaskStr('');
    }
    setOpenDatePicker(!isOpenDatePicker);
  };

  const handleOnBlur = (e) => handleInputOnChange(e);

  return (
    <FormGroupStyled>
      <FormLabel />
      <FormControl
        ref={ref}
        type={REGISTER_PERSONAL_DETAILS_DOB_FIELD.type}
        name={REGISTER_DOB_NAME}
        value={formatter.mask(dateMaskStr, dateFormat)}
        placeholder={REGISTER_PERSONAL_DETAILS_DOB_FIELD.placeholder}
        onClick={() => setOpenDatePicker(false)}
        onChange={handleInputOnChange}
        onBlur={handleOnBlur}
        onKeyDown={handleInputOnKeyDown}
        isInvalid={validation[REGISTER_DOB_NAME]}
        readOnly={REGISTER_PERSONAL_DETAILS_DOB_FIELD.isReadOnly}
        inputMode="numeric"
      />
      {isShowDatePickerIcon && (
        <CalendarIcon
          name={REGISTER_DOB_NAME}
          color="var(--ds-c-grey-dark)"
          size={{ width: 24, height: 24 }}
          onClick={handleOnToggleDatePicker}
          styles={{
            position: 'absolute',
            top: '36px',
            right: '10px',
            cursor: 'pointer',
          }}
        />
      )}
      {isOpenDatePicker && (
        <CustomDatepickerSelected
          isOpen={isOpenDatePicker}
          date={datePickerISO}
          onChange={handleOnChange}
          onClose={handleOnToggleDatePicker}
        />
      )}
      <FormControlFeedback value={t(validation[REGISTER_DOB_NAME])} />
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
  }
`;

const FormControl = styled(Form.Control)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: var(--ds-c-grey-dark);
  height: 44px;
  border: 1px solid var(--ds-c-grey-light);
  border-radius: 12px;
  padding-right: 8px;
  background: var(--ds-c-white);

  &:focus {
    border: 1px solid var(--ds-c-grey-dark) !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &:invalid,
  &:invalid:focus,
  &.is-invalid {
    border: 1px solid var(--ds-c-red) !important;
    outline: none !important;
    box-shadow: none !important;
    background-image: none !important;
  }

  &[readonly] {
    background: var(--ds-c-white);
  }

  &::placeholder {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    color: var(--ds-c-blue-disabled) !important;

    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  &[type='date']::-webkit-calendar-picker-indicator {
    background: none !important;
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export default FormInputDatepickerValidation;
